





































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import { StickerInfo, Sticker } from 'ncp-api-supporter';
import { getToday, addMonth } from '@/utils/dateUtils';
@Component({
  components: {
    PeriodDateCalendar,
    DateCalendar,
  },
})
export default class CheckIcons extends Vue {
  @Prop({ required: true }) immutableFields!: string[];
  @Prop({ required: true }) error!: any;
  @Prop({ required: true }) mallNo!: number;
  @Prop({ required: true }) deleteIconsError!: () => void;
  @PropSync('stickerInfos') stickerInfosSync!: StickerInfo[];

  private startYmdt = getToday();
  private endYmdt = addMonth(new Date(), 3);
  private isDataRender = false;
  private isImmutable = this.immutableFields.includes('stickerNos');
  private icons: Sticker[] = [];

  private readonly CheckIconsPeriodOption = {
    dateType: 'Ymd',
    havePeriodBtn: false,
    fromRanges: getToday(),
  };
  @Watch('stickerInfosSync')
  setDate() {
    if (!this.isDataRender && this.stickerInfosSync.length) {
      const existDateInfo = this.stickerInfosSync.find(({ displayStartedAt: date }) => date);

      this.startYmdt = existDateInfo?.displayStartedAt.split(' ')[0] ?? getToday();
      this.endYmdt = existDateInfo?.displayEndedAt.split(' ')[0] ?? addMonth(new Date(), 3);
      this.isDataRender = true;
    }
  }
  @Watch('startYmdt')
  changeStartYmdt() {
    this.stickerInfosSync = this.stickerInfosSync.map(info => {
      if (!info.displayStartedAt) {
        return info;
      }
      return { ...info, displayStartedAt: this.startYmdt + ' 00:00:00' };
    });
  }
  @Watch('endYmdt')
  changeEndYmdt() {
    this.stickerInfosSync = this.stickerInfosSync.map(info => {
      if (!info.displayStartedAt) {
        return info;
      }
      return { ...info, displayEndedAt: this.endYmdt + ' 23:59:59' };
    });
  }

  @Watch('error')
  private async getNewStickersInfo() {
    this.error.hasOwnProperty('INVALID_STICKER') && this.handleIcons();
  }

  @Watch('mallNo')
  handleIcons() {
    this.stickerInfosSync = [];
    this.setIcons();
  }

  private handleIconNos(value: string, isDate: boolean) {
    const isIncludeNo = this.stickerInfosSync.find(({ stickerNo }) => stickerNo === Number(value));
    if (isIncludeNo) {
      this.stickerInfosSync = this.stickerInfosSync.filter(({ stickerNo }) => stickerNo !== Number(value));
      return;
    }
    this.stickerInfosSync.push({
      stickerNo: Number(value),
      displayStartedAt: isDate ? this.startYmdt + ' 00:00:00' : null,
      displayEndedAt: isDate ? this.endYmdt + ' 23:59:59' : null,
    });
  }

  private async setIcons() {
    const { data } = await this.$api.getStickersByMallNo({
      params: {
        mallNo: this.mallNo,
      },
    });

    this.icons = data;
  }
}
